import { z } from "zod";

export const ProjectStatus = z.enum(["Active", "Expired"]);

export type ProjectStatusEnum = z.infer<typeof ProjectStatus>;

export const ProjectStatusDisplayName: Record<ProjectStatusEnum, string> = {
  [ProjectStatus.enum.Active]: "Active",
  [ProjectStatus.enum.Expired]: "Expired",
};
